import type { EmptyCallback } from '../../utils/global-types';
import { onClickOutside } from '@vueuse/core'
import { nextTick, ref, type DirectiveBinding } from 'vue';

interface ButtonElement extends HTMLInputElement {
    cleanup?: EmptyCallback
}

async function positionMenu(el: ButtonElement) {
    await nextTick()
    const rect = el.getBoundingClientRect();
    const menu = el.nextElementSibling;

    if (!menu) { return; }

    if (menu?.classList.contains('dropdown-menu-left')
        || menu?.classList.contains('dropdown-menu-right')) {
        return;
    }

    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    menu.classList.remove('dropdown-menu-left', 'dropdown-menu-right');

    if (spaceRight >= spaceLeft) {
        menu.classList.add('dropdown-menu-left');
    } else {
        menu.classList.add('dropdown-menu-right');
    }
}

export default {
    mounted(el: ButtonElement, binding: DirectiveBinding) {
        const parent = el.parentNode as HTMLElement;
        const isOpen = ref(false)

        onClickOutside(el, () => {
            if (!isOpen.value) {
                return
            }
            onClick()
        })

        const onClick = async () => {
            const newState = !isOpen.value
            isOpen.value = newState;

            if (binding.value?.isOpen) {
                Object.assign(binding.value.isOpen, { isOpen: newState });
            }

            if (parent) {
                parent.classList.toggle('open')
            }

            if (isOpen.value) {
                await positionMenu(el);
            }
        }

        el.addEventListener('click', onClick)

        el.cleanup = () => {
            el.removeEventListener('click', onClick)
        }
    },

    unmounted(el: ButtonElement) {
        el.cleanup?.()
        delete el.cleanup
    }
}
